async function getBrowsingContext() {
  try {
    const response = await fetch(
      window.Shopify.routes.root +
      'browsing_context_suggestions.json' +
      '?country[enabled]=true' +
      `&country[exclude]=${window.Shopify.country}` +
      '&language[enabled]=true' +
      `&language[exclude]=${window.Shopify.language}`
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching browsing context:', error);
  }
}


// fetch the client’s public IP (this is so we can access website)
async function getClientIP() {
  try {
    const resp = await fetch('https://api.ipify.org/?format=json');
    const { ip } = await resp.json();
    return ip;
  } catch (e) {
    console.error('Error fetching IP address:', e);
    return null;
  }
}

async function resolveLink(currentLink, fallbackLink) {
  // swap .com for .ca (only the first occurrence, word-boundary)
  const correctedLink = currentLink.replace(/\.com\b/, '.ca');

  try {
    // Try a HEAD request first (lightweight)
    const res = await fetch(correctedLink, { method: 'HEAD' });
    if (res.status != 404) {
      return correctedLink;
    } else {
      // server responded, but not 2xx
      return correctedLink;
    }
  } catch (err) {
    // network error or CORS denial
    return correctedLink;
  }
}

// Execute the function and handle redirect
async function checkAndRedirect() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("no_rule") === "true") {
      sessionStorage.setItem("no_rule", "true");
      return;
    }
    if (urlParams.get("no_rule") === "false") {
      sessionStorage.removeItem("no_rule");
    }
    if (sessionStorage.getItem("no_rule") === "true") {
      return;
    }
    const data = await getBrowsingContext();
    const country = data.detected_values.country.handle;
    const client_id = await getClientIP();
    console.log('Detected country:', country);
    console.log("current href: ", window.location.href);
    /* console.log("theoretically correct redirect href: ", window.location.href.replace(/\.com\b/, '.ca')); */
    // If country is not Canada, redirect to the appropriate store
    if (country == 'CA' && client_id != "99.209.31.132" && client_id != "99.250.10.120" && client_id != "99.229.33.161" && client_id != "208.181.117.10" && client_id != "99.209.31.132") {
      // You can customize the redirect URL based on the country
      /* redirectUrl = `https://demonpowersports.ca/`; */
      const redirectUrl = await resolveLink(window.location.href, `https://demonpowersports.ca/`);
      console.log('Redirecting to:', redirectUrl);
      console.log(client_id);
      window.location.href = redirectUrl;
    }
  } catch (error) {
    console.error('Error in checkAndRedirect:', error);
  }
}

// Execute the check and redirect
//commented out for fifa
/* checkAndRedirect(); */

